import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/my-uploads')({
  staticData: toStaticData(CRT_ROUTES['/crt/my-uploads']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
